// utils/socket.js
import { io } from 'socket.io-client';
const URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:9001';
const socket = io(URL, { transports: ['websocket'], autoConnect: false });

export default socket;
